import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const apiUrl = import.meta.env.VITE_APP_API;

const baseQuery = fetchBaseQuery({
  baseUrl: apiUrl,
  prepareHeaders: (headers) => {
    const access_token = JSON.parse(localStorage.getItem("faceAuthTokenData"))?.token?.access;
    if (access_token) {
      headers.set("Authorization", `Bearer ${access_token}`);
    }
    return headers;
  },
});

export const promoCodesApi = createApi({
  reducerPath: "promoCodesApi",
  baseQuery,
  endpoints: (builder) => ({
    getPromoCodes: builder.query({
      query: ({ search = "", ordering = "", start_date = "", end_date = "" } = {}) =>
        `/api/course/admin/course_promocode?search=${search}&ordering=${ordering}&start_date=${start_date}&end_date=${end_date}`,
    }),
    getSinglePromo: builder.query({
      query: (id) => `/api/course/admin/course_promocode/${id}/`,
    }),
    postPromoCode: builder.mutation({
      query: (formData) => ({
        url: "/api/course/admin/course_promocode/",
        method: "POST",
        body: formData,
      }),
    }),
    patchPromoCode: builder.mutation({
      query: ({ id, formData }) => ({
        url: `/api/course/admin/course_promocode/${id}/`,
        method: "PATCH",
        body: formData,
      }),
    }),
    deletePromoCode: builder.mutation({
      query: (id) => ({
        url: `/api/course/admin/course_promocode/${id}/`,
        method: "DELETE",
      }),
    }),
  }),
});

export const { useGetPromoCodesQuery, useGetSinglePromoQuery, usePostPromoCodeMutation, usePatchPromoCodeMutation, useDeletePromoCodeMutation } = promoCodesApi;
